import React, { useState } from 'react'
import Modal from '../common/Modal'
import authService from '../../services/authService'

type Props = { isOpen: boolean; onClose: () => void }

const PasswordChangeModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const strengthOk = (p: string) => /[A-Z]/.test(p) && /[a-z]/.test(p) && /[0-9]/.test(p) && p.length >= 8

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setMessage('')
    if (!current || !next) return setError('Complete todos los campos')
    if (next !== confirm) return setError('Las contraseñas no coinciden')
    if (!strengthOk(next)) return setError('Contraseña muy débil')
    setLoading(true)
    try {
      await authService.changePassword({ old_password: current, new_password: next })
      setMessage('Contraseña cambiada exitosamente')
      setCurrent(''); setNext(''); setConfirm('')
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Error al cambiar contraseña')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Cambiar Contraseña">
      {message && <div className="mb-3 text-green-600 text-sm">{message}</div>}
      {error && <div className="mb-3 text-red-600 text-sm">{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Contraseña actual</label>
          <input type="password" className="w-full border rounded px-3 py-2" value={current} onChange={(e) => setCurrent(e.target.value)} />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nueva contraseña</label>
          <input type="password" className="w-full border rounded px-3 py-2" value={next} onChange={(e) => setNext(e.target.value)} />
          <p className="text-xs text-gray-500 mt-1">Mínimo 8 caracteres, 1 mayúscula, 1 minúscula, 1 número.</p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Confirmar nueva contraseña</label>
          <input type="password" className="w-full border rounded px-3 py-2" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded border">Cancelar</button>
          <button type="submit" disabled={loading} className={`px-4 py-2 rounded text-white ${loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'}`}>{loading ? 'Guardando...' : 'Cambiar Contraseña'}</button>
        </div>
      </form>
    </Modal>
  )
}

export default PasswordChangeModal


